"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { useLabels } from "@/lib/labels/LabelsProvider";
import { useConsent } from "./ConsentProvider";
import { ConsentPreferences } from "./ConsentPreferences";
import type { BannerStyle } from "./types";
interface ConsentBannerProps {
  bannerStyle: BannerStyle;
}
export function ConsentBanner(t0) {
  const $ = _c(42);
  const {
    bannerStyle
  } = t0;
  const {
    consent,
    isPreferencesOpen,
    updateConsent,
    acceptAll,
    rejectAll,
    closePreferences
  } = useConsent();
  const labels = useLabels();
  const consentLabels = labels.consent;
  const [mounted, setMounted] = useState(false);
  const [showPreferences, setShowPreferences] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setMounted(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  if (!mounted) {
    return null;
  }
  const shouldShow = consent === null || isPreferencesOpen;
  if (!shouldShow) {
    return null;
  }
  let t3;
  if ($[2] !== consentLabels.banner.title) {
    t3 = <h3 className="font-semibold text-base">{consentLabels.banner.title}</h3>;
    $[2] = consentLabels.banner.title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== consentLabels.banner.description) {
    t4 = <p className="text-sm text-muted-foreground">{consentLabels.banner.description}</p>;
    $[4] = consentLabels.banner.description;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== consent?.analytics || $[7] !== consent?.marketing || $[8] !== isPreferencesOpen || $[9] !== showPreferences || $[10] !== updateConsent) {
    t5 = (showPreferences || isPreferencesOpen) && <ConsentPreferences initialAnalytics={consent?.analytics ?? false} initialMarketing={consent?.marketing ?? false} onSave={updateConsent} />;
    $[6] = consent?.analytics;
    $[7] = consent?.marketing;
    $[8] = isPreferencesOpen;
    $[9] = showPreferences;
    $[10] = updateConsent;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== acceptAll || $[13] !== consentLabels.acceptAll || $[14] !== consentLabels.managePreferences || $[15] !== consentLabels.rejectAll || $[16] !== isPreferencesOpen || $[17] !== rejectAll || $[18] !== showPreferences) {
    t6 = !showPreferences && !isPreferencesOpen && <div className="flex flex-wrap gap-2"><button type="button" onClick={acceptAll} className="cursor-pointer py-2 px-4 rounded-md bg-primary text-primary-foreground text-sm font-medium hover:opacity-90 transition">{consentLabels.acceptAll}</button><button type="button" onClick={rejectAll} className="cursor-pointer py-2 px-4 rounded-md bg-muted text-foreground text-sm font-medium hover:opacity-90 transition">{consentLabels.rejectAll}</button><button type="button" onClick={() => setShowPreferences(true)} className="cursor-pointer py-2 px-4 text-sm text-muted-foreground underline hover:text-foreground transition">{consentLabels.managePreferences}</button></div>;
    $[12] = acceptAll;
    $[13] = consentLabels.acceptAll;
    $[14] = consentLabels.managePreferences;
    $[15] = consentLabels.rejectAll;
    $[16] = isPreferencesOpen;
    $[17] = rejectAll;
    $[18] = showPreferences;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t3 || $[21] !== t4 || $[22] !== t5 || $[23] !== t6) {
    t7 = <div className="space-y-3">{t3}{t4}{t5}{t6}</div>;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  const bannerContent = t7;
  if (bannerStyle === "overlay") {
    let t8;
    if ($[25] !== closePreferences) {
      t8 = open => !open && closePreferences();
      $[25] = closePreferences;
      $[26] = t8;
    } else {
      t8 = $[26];
    }
    let t9;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <Dialog.Overlay className="fixed inset-0 bg-black/50 z-9998" />;
      $[27] = t9;
    } else {
      t9 = $[27];
    }
    let t10;
    if ($[28] !== consentLabels.banner.title) {
      t10 = <Dialog.Title className="sr-only">{consentLabels.banner.title}</Dialog.Title>;
      $[28] = consentLabels.banner.title;
      $[29] = t10;
    } else {
      t10 = $[29];
    }
    let t11;
    if ($[30] !== bannerContent || $[31] !== t10) {
      t11 = <Dialog.Portal>{t9}<Dialog.Content className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-9999 w-[90vw] max-w-lg rounded-lg bg-card text-card-foreground p-6 shadow-lg" onInteractOutside={_temp}>{t10}{bannerContent}</Dialog.Content></Dialog.Portal>;
      $[30] = bannerContent;
      $[31] = t10;
      $[32] = t11;
    } else {
      t11 = $[32];
    }
    let t12;
    if ($[33] !== shouldShow || $[34] !== t11 || $[35] !== t8) {
      t12 = <Dialog.Root open={shouldShow} onOpenChange={t8}>{t11}</Dialog.Root>;
      $[33] = shouldShow;
      $[34] = t11;
      $[35] = t8;
      $[36] = t12;
    } else {
      t12 = $[36];
    }
    return t12;
  }
  let t8;
  if ($[37] !== bannerContent) {
    t8 = <div className="max-w-350 mx-auto">{bannerContent}</div>;
    $[37] = bannerContent;
    $[38] = t8;
  } else {
    t8 = $[38];
  }
  let t9;
  if ($[39] !== consentLabels.banner.title || $[40] !== t8) {
    t9 = <div className="fixed bottom-0 left-0 right-0 z-9999 bg-card text-card-foreground p-4 md:p-6 shadow-lg border-t-4 border-primary" role="dialog" aria-label={consentLabels.banner.title}>{t8}</div>;
    $[39] = consentLabels.banner.title;
    $[40] = t8;
    $[41] = t9;
  } else {
    t9 = $[41];
  }
  return t9;
}
function _temp(e) {
  return e.preventDefault();
}